module.exports = __webpack_public_path__ + "assets/img/duoyang_2.6057f60f.png";